import { DatabaseAction } from "../business-logic/ActionBehavior/Action";

const freeKickActions = [
  DatabaseAction.lineout,
  DatabaseAction.kickRestart,
  DatabaseAction.scrum,
  DatabaseAction.tapRestart,
  DatabaseAction.endOfHalf,
];
const penaltyActions = [
  ...freeKickActions,
  DatabaseAction.penaltyGoalKick,
  DatabaseAction.try,
];
export const openKickActions = [
  DatabaseAction.ballGrounded,
  DatabaseAction.chargedDownKick,
  DatabaseAction.intoTouch,
  DatabaseAction.knockOn,
  DatabaseAction.receiveKick,
  DatabaseAction.recoverKick,
  DatabaseAction.mark,
];
export const openPlayActions = [
  DatabaseAction.dropGoalKick,
  DatabaseAction.forwardPass,
  DatabaseAction.heldUpTry,
  DatabaseAction.intoTouch,
  DatabaseAction.knockOn,
  DatabaseAction.maulStart,
  DatabaseAction.offload,
  DatabaseAction.openPlayKick,
  DatabaseAction.tackled,
  DatabaseAction.turnover,
  DatabaseAction.try,
  DatabaseAction.ballGrounded,
];

const restartActions = [DatabaseAction.knockOn, DatabaseAction.openPlayKick];
export const pausePieceActions = [
  DatabaseAction.endOfHalf,
  DatabaseAction.forwardPass,
  DatabaseAction.freeKickWon,
  DatabaseAction.knockOn,
  DatabaseAction.maulStart,
  DatabaseAction.openPlayKick,
  DatabaseAction.phase,
  DatabaseAction.turnover,
];

export enum PossessionChange {
  currentEvent,
  nextEvent,
}

type ActionMapping = {
  previous: DatabaseAction[];
  next: DatabaseAction[];
  requiresPitchClick: boolean;
  possessionChange?: PossessionChange;
};

// TODO: action mapping for offload to not require location only if the previous action is a tackle
// TODO: ball grounded extra complexity with possession changing
// TODO: we could be smarter about when kickoff50_22_GL are acceptable for possession changing
// TODO: improve charged down kicks logic
export const databaseActionsMap: ActionMapping[] = [
  {
    previous: [DatabaseAction.heldUpTry],
    next: [DatabaseAction.kickoff, DatabaseAction.endOfHalf],
    requiresPitchClick: true,
    possessionChange: PossessionChange.nextEvent,
  },
  {
    previous: [DatabaseAction.conversionKickMiss, DatabaseAction.goalKickMade],
    next: [DatabaseAction.kickoff, DatabaseAction.endOfHalf],
    requiresPitchClick: false,
    possessionChange: PossessionChange.nextEvent,
  },
  {
    previous: [DatabaseAction.conversionGoalKick],
    next: [DatabaseAction.goalKickMade, DatabaseAction.conversionKickMiss],
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.phase],
    next: openPlayActions,
    requiresPitchClick: false,
  },
  {
    previous: [DatabaseAction.offload],
    next: openPlayActions,
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.ballGrounded],
    next: [
      DatabaseAction.kickoff,
      DatabaseAction.scrum,
      DatabaseAction.endOfHalf,
    ],
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.chargedDownKick],
    next: [
      DatabaseAction.intoTouch,
      DatabaseAction.knockOn,
      DatabaseAction.receiveKick,
      DatabaseAction.recoverKick,
    ],
    requiresPitchClick: false,
    possessionChange: PossessionChange.currentEvent,
  },
  {
    previous: [DatabaseAction.freeKickWon, DatabaseAction.mark],
    next: freeKickActions,
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.penaltyWon],
    next: penaltyActions,
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.dropGoalKick, DatabaseAction.penaltyGoalKick],
    next: [...openKickActions, DatabaseAction.goalKickMade],
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.kickRestart, DatabaseAction.openPlayKick],
    next: openKickActions,
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.scrum],
    next: [...pausePieceActions, DatabaseAction.scrumReset],
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.ruck],
    next: pausePieceActions,
    requiresPitchClick: false,
  },
  {
    previous: [DatabaseAction.scrumReset],
    next: [DatabaseAction.scrum, DatabaseAction.endOfHalf],
    requiresPitchClick: false,
  },
  {
    previous: [DatabaseAction.maulStart],
    next: [
      DatabaseAction.intoTouch,
      DatabaseAction.knockOn,
      DatabaseAction.maulEnd,
      DatabaseAction.turnover,
      DatabaseAction.try,
    ],
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.tackled],
    next: [
      DatabaseAction.forwardPass,
      DatabaseAction.intoTouch,
      DatabaseAction.knockOn,
      DatabaseAction.offload,
      DatabaseAction.ruck,
      DatabaseAction.try,
      DatabaseAction.turnover,
    ],
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.maulEnd],
    next: [
      ...restartActions,
      DatabaseAction.phase,
      DatabaseAction.ruck,
      DatabaseAction.tackled,
      DatabaseAction.try,
      DatabaseAction.turnover,
    ],
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.tapRestart],
    next: [...openPlayActions, ...restartActions],
    requiresPitchClick: false,
  },
  {
    previous: [DatabaseAction.receiveKick],
    next: [
      DatabaseAction.intoTouch,
      DatabaseAction.knockOn,
      DatabaseAction.mark,
      DatabaseAction.offload,
      DatabaseAction.openPlayKick,
      DatabaseAction.phase,
      DatabaseAction.tackled,
      DatabaseAction.turnover,
      DatabaseAction.ballGrounded,
    ],
    requiresPitchClick: true,
    possessionChange: PossessionChange.currentEvent,
  },
  {
    previous: [DatabaseAction.recoverKick],
    next: openPlayActions,
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.forwardPass, DatabaseAction.knockOn],
    next: [
      DatabaseAction.endOfHalf,
      DatabaseAction.intoTouch,
      DatabaseAction.scrum,
      DatabaseAction.turnover,
    ],
    requiresPitchClick: true,
    possessionChange: PossessionChange.nextEvent,
  },
  {
    previous: [DatabaseAction.try],
    next: [DatabaseAction.conversionGoalKick],
    requiresPitchClick: true,
  },
  {
    previous: [DatabaseAction.endOfHalf],
    next: [DatabaseAction.kickoff],
    requiresPitchClick: false,
  },
  {
    previous: [DatabaseAction.intoTouch],
    next: [
      DatabaseAction.freeKickWon,
      DatabaseAction.kickoff,
      DatabaseAction.lineout,
      DatabaseAction.scrum,
      DatabaseAction.endOfHalf,
    ],
    requiresPitchClick: true,
  },
];
